import * as React from 'react';

import { Layout } from '../../components/Layout';
import { CalculateResultModalContainer } from '../CalculateResultModalContainer';
import { Calculator } from '../Calculator';

export const LayoutContainer: React.FC = () => (
  <>
    <Layout calculator={<Calculator />} />
    <CalculateResultModalContainer />
  </>
);
